// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flex_EKocy {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
}
.flex_EKocy.flex-rowS_mEU8b {
  gap: var( --size-small );
  display: flex;
  flex-direction: row;
}
.flex_EKocy.flex-rowM_dkX22 {
  gap: var( --size-padMedium );
  display: flex;
  align-items: center;
  flex-direction: row;
}
.flex_EKocy.flex-rowSpaceBetween_jHv0W {
  display: flex;
  justify-content: space-between;
}
.flex_EKocy.flex-rowM_dkX22.flex-rowMEnd_ptXm_ {
  display: flex;
  justify-content: flex-end;
}
.flex_EKocy.flex-col_bdUO1 {
  display: flex;
  align-items: stretch;
  flex-direction: column;
  justify-content: flex-start;
}
.flex_EKocy.flex-col_bdUO1.flex-colS_qus8Z {
  gap: var( --size-padSmall );
  display: flex;
  flex-direction: column;
}
.flex_EKocy.flex-col_bdUO1.flex-colM_nHyiB {
  gap: var( --size-padMedium );
  display: flex;
  flex-direction: column;
}
.flex_EKocy.flex-col_bdUO1.flex-colL_FglUl {
  gap: var( --size-padLarge );
  display: flex;
  flex-direction: column;
}
.flex_EKocy.flex-col_bdUO1.flex-colXL_aDtre {
  gap: var( --size-padXXLarge );
  display: flex;
  flex-direction: column;
}
.flex_EKocy.flex-col_bdUO1.flex-colXXL_Q1MZk {
  gap: 40px;
  display: flex;
  flex-direction: column;
}
.flex_EKocy.flex-hNavBar_DNNc9 {
  gap: 0px;
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  flex-direction: row;
  justify-content: flex-start;
}
.flex_EKocy.flex-vNavBar_iQ87V {
  gap: 0px;
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  flex-direction: column;
  justify-content: flex-start;
}
.flex_EKocy.flex-itemBar_TZMCA {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  flex-direction: row;
  justify-content: flex-end;
}
.flex_EKocy.flex-screenTitle_mJ3na {
  gap: var( --size-padMedium );
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
}
.flex_EKocy.flex-screenTitleControls_HAq2r {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.flex_EKocy.flex-topNavBar_mLI9S {
  gap: var( --size-large );
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  flex-direction: row;
  justify-content: flex-start;
}
.flex_EKocy.flex-topNavControls_fMobU {
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  flex-direction: row;
  justify-content: space-between;
}
.flex_EKocy.flex-sideNav_FpExH {
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  flex-direction: column;
  justify-content: flex-start;
}
.flex_EKocy.flex-loadingScreen_uKELL {
  gap: var( --size-padLarge );
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.flex_EKocy.flex-tableToolbar_F9rqx {
  display: flex;
  align-items: center;
  padding-left: var( --size-padLarge );
  padding-right: var( --size-padLarge );
  flex-direction: row;
  justify-content: space-between;
}
.flex_EKocy.flex-rowL_DxzHM {
  gap: var( --size-padLarge );
  display: flex;
  flex-direction: row;
}
.flex_EKocy.flex-rowM_dkX22.flex-tableHeader_rdSrW {
  gap: var( --size-small );
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-around;
}
.flex_EKocy.flex-aggBucketVertical_LhC9N {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
}
.flex_EKocy.flex-aggBucketHorizontal_d16NJ {
  gap: 52px;
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  flex-direction: row;
  justify-content: flex-start;
}
.flex_EKocy.flex-colSpaceBetween_cgmiG {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.flex_EKocy.flex-rowM_dkX22.flex-rowMCenter_EGWV9 {
  gap: var( --size-padMedium );
  display: flex;
  align-items: center;
  flex-direction: row;
}
.flex_EKocy.flex-col_bdUO1.flex-colM_nHyiB.flex-colMCenter_YrHoj {
  display: flex;
  align-items: center;
}
.flex_EKocy.flex-col_bdUO1.flex-colS_qus8Z.flex-colSCenter_chMPG {
  display: flex;
  align-items: center;
}
.flex_EKocy.flex-col_bdUO1.flex-colM_nHyiB.flex-colMStart_Y04zM {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.flex_EKocy.flex-col_bdUO1.flex-colS_qus8Z.flex-colSStart_A8c4j {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.flex_EKocy.flex-rowM_dkX22.flex-rowMCenter_EGWV9.flex-rowMMiddle_OU5A8 {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.flex_EKocy.flex-col_bdUO1.flex-colM_nHyiB.flex-mobileNavRoutes_BD6qq {
  padding-top: 0px;
}
.flex_EKocy.flex-sideNavBarCollapse_F2uuk {
  display: flex;
  padding: 8px;
  flex-direction: column;
}
.flex_EKocy.flex-itemBar_TZMCA.flex-footerItemBar_fZb4E {
  gap: var( --size-padLarge );
  display: flex;
  padding-left: var( --size-padMedium );
  flex-direction: row-reverse;
}
.flex_EKocy.flex-layoutActionBar_fK7Rx {
  gap: var( --size-padSmall );
  display: flex;
  flex-direction: row;
}
.flex_EKocy.flex-center_LD_3S {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.flex_EKocy.flex-mobileOptNavTitle_ZtqzP {
  display: flex;
  align-items: center;
  flex-direction: row;
}
.flex_EKocy.flex-mobileOptNavTitleControls_zOk8S {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-end;
}
.flex_EKocy.flex-sidenavbarcollapse_ORzsC {
  display: flex;
  padding: var( --size-padSmall ) var( --size-padMedium );
  flex-direction: column;
}
.flex_EKocy.flex-pairDetail_eIcdD {
  display: flex;
  flex-wrap: wrap;
}
.flex_EKocy.flex-bulkCreateResults_T_JN9 {
  display: flex;
  align-items: center;
  padding-top: var( --size-padLarge );
  flex-direction: row;
  padding-bottom: var( --size-padLarge );
}
.flex_EKocy.flex-rowXXL_XweK4 {
  gap: var( --size-padXXLarge );
  display: flex;
  flex-direction: row;
}
.flex_EKocy.flex-rowM_dkX22.flex-rowMStart_QvUFr {
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.flex_EKocy.flex-sideNavControls_CEOQZ {
  border-top: 1px solid var( --color-base100 );
}
.flex_EKocy.flex-rowSpaceBetween_jHv0W.flex-rowSpaceBetweenCenter_tg8Vf {
  display: flex;
  align-items: center;
}
.flex_EKocy.flex-rowSpaceAround_VQfIQ {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-around;
}
.flex_EKocy.flex-rowStretch_QJtJy {
  display: flex;
  align-items: stretch;
  flex-direction: row;
  justify-content: center;
}
.flex_EKocy.flex-sortFilterBar_pWq_T {
  gap: 8px;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
}
.flex_EKocy.flex-preConditionBar__bsox {
  display: flex;
  align-items: center;
  justify-content: center;
}
.flex_EKocy.flex-filterBar_YQRLn {
  gap: 8px;
  display: flex;
  flex-direction: row;
}
.flex_EKocy.flex-conditionRow_jsVlX {
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  justify-content: flex-start;
}
.flex_EKocy.flex-conditionRowEmpty_bhfGm {
  display: flex;
  align-items: center;
  justify-content: center;
}
.flex_EKocy.flex-rowM_dkX22.flex-rowMEnd_ptXm_.flex-rowMEndCenter_OG_NT {
  display: flex;
  align-items: center;
  flex-direction: row;
}
.flex_EKocy.flex-pairTitleControls_drFad {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.flex_EKocy.flex-rowS_mEU8b.flex-rowSWrap_YYE7B {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}
.flex_EKocy.flex-rowS_mEU8b.flex-rowSWrap_YYE7B.flex-rowSWrapEnd_eYrkI {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-end;
}
.flex_EKocy.flex-rowS_mEU8b.flex-rowSCenter_EsiUM {
  display: flex;
  align-items: center;
}
.flex_EKocy.flex-rowM_dkX22.flex-rowMTop_DWwfK {
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.flex_EKocy.flex-rowL_DxzHM.flex-rowXL_KEkT1 {
  gap: var( --size-padXLarge );
  display: flex;
  flex-direction: row;
}
.flex_EKocy.flex-col_bdUO1.flex-colL_FglUl.flex-colLCenter_HKadq {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.flex_EKocy.flex-altLoginMethods_TLlDZ {
  gap: var( --size-padMedium );
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  flex-direction: row;
}
.flex_EKocy.flex-rowEnd_gFplI {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.flex_EKocy.flex-loginPane_drkdG {
  display: flex;
  row-gap: var( --size-padLarge );
  flex-wrap: wrap;
  column-gap: var( --size-padXXLarge );
  align-items: stretch;
  flex-direction: row;
  justify-content: flex-start;
}
.flex_EKocy.flex-col_bdUO1.flex-colCenter_WyRfm {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.flex_EKocy.flex-col_bdUO1.flex-colM_nHyiB.flex-colMCenter_YrHoj.flex-colMCenterMiddle_WLOnX {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.flex_EKocy.flex-col_bdUO1.flex-colL_FglUl.flex-colLCenter_HKadq.flex-colLCenterMiddle_kjXM7 {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.flex_EKocy.flex-col_bdUO1.flex-colCenter_WyRfm.flex-colCenterMiddle_mD1TB {
  gap: var( --size-padMedium );
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.flex_EKocy.flex-col_bdUO1.flex-colM_nHyiB.flex-colMStart_Y04zM.flex-colLStart_snVAi {
  gap: var( --size-padLarge );
  display: flex;
  flex-direction: column;
}
.flex_EKocy.flex-col_bdUO1.flex-colCenter_WyRfm.flex-colCenterStretch_tX7Wb {
  display: flex;
  align-items: stretch;
  flex-direction: column;
  justify-content: center;
}
.flex_EKocy.flex-tableToolbar_F9rqx.flex-rsrcToolbar_cCT9X {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-end;
}
.flex_EKocy.flex-aggregationBucketFlex_yzSFr {
  display: flex;
  row-gap: var( --size-padSmall );
  align-items: flex-start;
  flex-direction: column;
}
.flex_EKocy.flex-aggregationContainerFlex_Zx3Gm {
  display: flex;
  row-gap: var( --size-padSmall );
  align-items: flex-start;
  flex-direction: column;
}
.flex_EKocy.flex-rowS_mEU8b.flex-rowSReverse_PQNdp {
  display: flex;
  flex-direction: row-reverse;
}
.flex_EKocy.flex-toast_XIW3m {
  gap: var( --size-padMedium );
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
}
.flex_EKocy.flex-header_Fdqq6 {
  display: flex;
  padding: 20px 15px;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.flex_EKocy.flex-collection_oobag {
  display: flex;
  padding: 20px;
  flex-wrap: wrap;
  align-content: flex-start;
  flex-direction: row;
}
.flex_EKocy.flex-projectButton_apmPQ {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: space-between;
}
.flex_EKocy.flex-actionBarHorizontal_B7Szx {
  display: flex;
  align-items: flex-start;
}
.flex_EKocy.flex-conditionRowFlex_OAVHQ {
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  flex-direction: row;
  justify-content: flex-start;
}
.flex-actionBarDashboard_vAGzb {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/theme/Flex.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,wBAAwB;EACxB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,4BAA4B;EAC5B,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,wBAAwB;EACxB,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,qCAAqC;EACrC,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAC3B,aAAa;EACb,qCAAqC;EACrC,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,uDAAuD;EACvD,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,mBAAmB;EACnB,sCAAsC;AACxC;AACA;EACE,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,QAAQ;EACR,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,4BAA4B;EAC5B,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,eAAe;EACf,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B","sourcesContent":[".flex {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  flex-direction: row;\n  justify-content: flex-start;\n}\n.flex.flex-rowS {\n  gap: var( --size-small );\n  display: flex;\n  flex-direction: row;\n}\n.flex.flex-rowM {\n  gap: var( --size-padMedium );\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n}\n.flex.flex-rowSpaceBetween {\n  display: flex;\n  justify-content: space-between;\n}\n.flex.flex-rowM.flex-rowMEnd {\n  display: flex;\n  justify-content: flex-end;\n}\n.flex.flex-col {\n  display: flex;\n  align-items: stretch;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n.flex.flex-col.flex-colS {\n  gap: var( --size-padSmall );\n  display: flex;\n  flex-direction: column;\n}\n.flex.flex-col.flex-colM {\n  gap: var( --size-padMedium );\n  display: flex;\n  flex-direction: column;\n}\n.flex.flex-col.flex-colL {\n  gap: var( --size-padLarge );\n  display: flex;\n  flex-direction: column;\n}\n.flex.flex-col.flex-colXL {\n  gap: var( --size-padXXLarge );\n  display: flex;\n  flex-direction: column;\n}\n.flex.flex-col.flex-colXXL {\n  gap: 40px;\n  display: flex;\n  flex-direction: column;\n}\n.flex.flex-hNavBar {\n  gap: 0px;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  flex-direction: row;\n  justify-content: flex-start;\n}\n.flex.flex-vNavBar {\n  gap: 0px;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n.flex.flex-itemBar {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n.flex.flex-screenTitle {\n  gap: var( --size-padMedium );\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  flex-direction: row;\n  justify-content: flex-start;\n}\n.flex.flex-screenTitleControls {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.flex.flex-topNavBar {\n  gap: var( --size-large );\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  flex-direction: row;\n  justify-content: flex-start;\n}\n.flex.flex-topNavControls {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.flex.flex-sideNav {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n.flex.flex-loadingScreen {\n  gap: var( --size-padLarge );\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n}\n.flex.flex-tableToolbar {\n  display: flex;\n  align-items: center;\n  padding-left: var( --size-padLarge );\n  padding-right: var( --size-padLarge );\n  flex-direction: row;\n  justify-content: space-between;\n}\n.flex.flex-rowL {\n  gap: var( --size-padLarge );\n  display: flex;\n  flex-direction: row;\n}\n.flex.flex-rowM.flex-tableHeader {\n  gap: var( --size-small );\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: space-around;\n}\n.flex.flex-aggBucketVertical {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.flex.flex-aggBucketHorizontal {\n  gap: 52px;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: flex-start;\n  flex-direction: row;\n  justify-content: flex-start;\n}\n.flex.flex-colSpaceBetween {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.flex.flex-rowM.flex-rowMCenter {\n  gap: var( --size-padMedium );\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n}\n.flex.flex-col.flex-colM.flex-colMCenter {\n  display: flex;\n  align-items: center;\n}\n.flex.flex-col.flex-colS.flex-colSCenter {\n  display: flex;\n  align-items: center;\n}\n.flex.flex-col.flex-colM.flex-colMStart {\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n}\n.flex.flex-col.flex-colS.flex-colSStart {\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n}\n.flex.flex-rowM.flex-rowMCenter.flex-rowMMiddle {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\n.flex.flex-col.flex-colM.flex-mobileNavRoutes {\n  padding-top: 0px;\n}\n.flex.flex-sideNavBarCollapse {\n  display: flex;\n  padding: 8px;\n  flex-direction: column;\n}\n.flex.flex-itemBar.flex-footerItemBar {\n  gap: var( --size-padLarge );\n  display: flex;\n  padding-left: var( --size-padMedium );\n  flex-direction: row-reverse;\n}\n.flex.flex-layoutActionBar {\n  gap: var( --size-padSmall );\n  display: flex;\n  flex-direction: row;\n}\n.flex.flex-center {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n}\n.flex.flex-mobileOptNavTitle {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n}\n.flex.flex-mobileOptNavTitleControls {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n.flex.flex-sidenavbarcollapse {\n  display: flex;\n  padding: var( --size-padSmall ) var( --size-padMedium );\n  flex-direction: column;\n}\n.flex.flex-pairDetail {\n  display: flex;\n  flex-wrap: wrap;\n}\n.flex.flex-bulkCreateResults {\n  display: flex;\n  align-items: center;\n  padding-top: var( --size-padLarge );\n  flex-direction: row;\n  padding-bottom: var( --size-padLarge );\n}\n.flex.flex-rowXXL {\n  gap: var( --size-padXXLarge );\n  display: flex;\n  flex-direction: row;\n}\n.flex.flex-rowM.flex-rowMStart {\n  display: flex;\n  align-items: flex-start;\n  flex-direction: row;\n}\n.flex.flex-sideNavControls {\n  border-top: 1px solid var( --color-base100 );\n}\n.flex.flex-rowSpaceBetween.flex-rowSpaceBetweenCenter {\n  display: flex;\n  align-items: center;\n}\n.flex.flex-rowSpaceAround {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: space-around;\n}\n.flex.flex-rowStretch {\n  display: flex;\n  align-items: stretch;\n  flex-direction: row;\n  justify-content: center;\n}\n.flex.flex-sortFilterBar {\n  gap: 8px;\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: flex-start;\n}\n.flex.flex-preConditionBar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.flex.flex-filterBar {\n  gap: 8px;\n  display: flex;\n  flex-direction: row;\n}\n.flex.flex-conditionRow {\n  display: flex;\n  align-items: flex-start;\n  flex-direction: row;\n  justify-content: flex-start;\n}\n.flex.flex-conditionRowEmpty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.flex.flex-rowM.flex-rowMEnd.flex-rowMEndCenter {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n}\n.flex.flex-pairTitleControls {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n.flex.flex-rowS.flex-rowSWrap {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n}\n.flex.flex-rowS.flex-rowSWrap.flex-rowSWrapEnd {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n.flex.flex-rowS.flex-rowSCenter {\n  display: flex;\n  align-items: center;\n}\n.flex.flex-rowM.flex-rowMTop {\n  display: flex;\n  align-items: flex-start;\n  flex-direction: row;\n}\n.flex.flex-rowL.flex-rowXL {\n  gap: var( --size-padXLarge );\n  display: flex;\n  flex-direction: row;\n}\n.flex.flex-col.flex-colL.flex-colLCenter {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n}\n.flex.flex-altLoginMethods {\n  gap: var( --size-padMedium );\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  flex-direction: row;\n}\n.flex.flex-rowEnd {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n.flex.flex-loginPane {\n  display: flex;\n  row-gap: var( --size-padLarge );\n  flex-wrap: wrap;\n  column-gap: var( --size-padXXLarge );\n  align-items: stretch;\n  flex-direction: row;\n  justify-content: flex-start;\n}\n.flex.flex-col.flex-colCenter {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n.flex.flex-col.flex-colM.flex-colMCenter.flex-colMCenterMiddle {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n}\n.flex.flex-col.flex-colL.flex-colLCenter.flex-colLCenterMiddle {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n}\n.flex.flex-col.flex-colCenter.flex-colCenterMiddle {\n  gap: var( --size-padMedium );\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n}\n.flex.flex-col.flex-colM.flex-colMStart.flex-colLStart {\n  gap: var( --size-padLarge );\n  display: flex;\n  flex-direction: column;\n}\n.flex.flex-col.flex-colCenter.flex-colCenterStretch {\n  display: flex;\n  align-items: stretch;\n  flex-direction: column;\n  justify-content: center;\n}\n.flex.flex-tableToolbar.flex-rsrcToolbar {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n.flex.flex-aggregationBucketFlex {\n  display: flex;\n  row-gap: var( --size-padSmall );\n  align-items: flex-start;\n  flex-direction: column;\n}\n.flex.flex-aggregationContainerFlex {\n  display: flex;\n  row-gap: var( --size-padSmall );\n  align-items: flex-start;\n  flex-direction: column;\n}\n.flex.flex-rowS.flex-rowSReverse {\n  display: flex;\n  flex-direction: row-reverse;\n}\n.flex.flex-toast {\n  gap: var( --size-padMedium );\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n.flex.flex-header {\n  display: flex;\n  padding: 20px 15px;\n  align-items: center;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.flex.flex-collection {\n  display: flex;\n  padding: 20px;\n  flex-wrap: wrap;\n  align-content: flex-start;\n  flex-direction: row;\n}\n.flex.flex-projectButton {\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.flex.flex-actionBarHorizontal {\n  display: flex;\n  align-items: flex-start;\n}\n.flex.flex-conditionRowFlex {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  flex-direction: row;\n  justify-content: flex-start;\n}\n.flex-actionBarDashboard {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flex": `flex_EKocy`,
	"flex-rowS": `flex-rowS_mEU8b`,
	"flex-rowM": `flex-rowM_dkX22`,
	"flex-rowSpaceBetween": `flex-rowSpaceBetween_jHv0W`,
	"flex-rowMEnd": `flex-rowMEnd_ptXm_`,
	"flex-col": `flex-col_bdUO1`,
	"flex-colS": `flex-colS_qus8Z`,
	"flex-colM": `flex-colM_nHyiB`,
	"flex-colL": `flex-colL_FglUl`,
	"flex-colXL": `flex-colXL_aDtre`,
	"flex-colXXL": `flex-colXXL_Q1MZk`,
	"flex-hNavBar": `flex-hNavBar_DNNc9`,
	"flex-vNavBar": `flex-vNavBar_iQ87V`,
	"flex-itemBar": `flex-itemBar_TZMCA`,
	"flex-screenTitle": `flex-screenTitle_mJ3na`,
	"flex-screenTitleControls": `flex-screenTitleControls_HAq2r`,
	"flex-topNavBar": `flex-topNavBar_mLI9S`,
	"flex-topNavControls": `flex-topNavControls_fMobU`,
	"flex-sideNav": `flex-sideNav_FpExH`,
	"flex-loadingScreen": `flex-loadingScreen_uKELL`,
	"flex-tableToolbar": `flex-tableToolbar_F9rqx`,
	"flex-rowL": `flex-rowL_DxzHM`,
	"flex-tableHeader": `flex-tableHeader_rdSrW`,
	"flex-aggBucketVertical": `flex-aggBucketVertical_LhC9N`,
	"flex-aggBucketHorizontal": `flex-aggBucketHorizontal_d16NJ`,
	"flex-colSpaceBetween": `flex-colSpaceBetween_cgmiG`,
	"flex-rowMCenter": `flex-rowMCenter_EGWV9`,
	"flex-colMCenter": `flex-colMCenter_YrHoj`,
	"flex-colSCenter": `flex-colSCenter_chMPG`,
	"flex-colMStart": `flex-colMStart_Y04zM`,
	"flex-colSStart": `flex-colSStart_A8c4j`,
	"flex-rowMMiddle": `flex-rowMMiddle_OU5A8`,
	"flex-mobileNavRoutes": `flex-mobileNavRoutes_BD6qq`,
	"flex-sideNavBarCollapse": `flex-sideNavBarCollapse_F2uuk`,
	"flex-footerItemBar": `flex-footerItemBar_fZb4E`,
	"flex-layoutActionBar": `flex-layoutActionBar_fK7Rx`,
	"flex-center": `flex-center_LD_3S`,
	"flex-mobileOptNavTitle": `flex-mobileOptNavTitle_ZtqzP`,
	"flex-mobileOptNavTitleControls": `flex-mobileOptNavTitleControls_zOk8S`,
	"flex-sidenavbarcollapse": `flex-sidenavbarcollapse_ORzsC`,
	"flex-pairDetail": `flex-pairDetail_eIcdD`,
	"flex-bulkCreateResults": `flex-bulkCreateResults_T_JN9`,
	"flex-rowXXL": `flex-rowXXL_XweK4`,
	"flex-rowMStart": `flex-rowMStart_QvUFr`,
	"flex-sideNavControls": `flex-sideNavControls_CEOQZ`,
	"flex-rowSpaceBetweenCenter": `flex-rowSpaceBetweenCenter_tg8Vf`,
	"flex-rowSpaceAround": `flex-rowSpaceAround_VQfIQ`,
	"flex-rowStretch": `flex-rowStretch_QJtJy`,
	"flex-sortFilterBar": `flex-sortFilterBar_pWq_T`,
	"flex-preConditionBar": `flex-preConditionBar__bsox`,
	"flex-filterBar": `flex-filterBar_YQRLn`,
	"flex-conditionRow": `flex-conditionRow_jsVlX`,
	"flex-conditionRowEmpty": `flex-conditionRowEmpty_bhfGm`,
	"flex-rowMEndCenter": `flex-rowMEndCenter_OG_NT`,
	"flex-pairTitleControls": `flex-pairTitleControls_drFad`,
	"flex-rowSWrap": `flex-rowSWrap_YYE7B`,
	"flex-rowSWrapEnd": `flex-rowSWrapEnd_eYrkI`,
	"flex-rowSCenter": `flex-rowSCenter_EsiUM`,
	"flex-rowMTop": `flex-rowMTop_DWwfK`,
	"flex-rowXL": `flex-rowXL_KEkT1`,
	"flex-colLCenter": `flex-colLCenter_HKadq`,
	"flex-altLoginMethods": `flex-altLoginMethods_TLlDZ`,
	"flex-rowEnd": `flex-rowEnd_gFplI`,
	"flex-loginPane": `flex-loginPane_drkdG`,
	"flex-colCenter": `flex-colCenter_WyRfm`,
	"flex-colMCenterMiddle": `flex-colMCenterMiddle_WLOnX`,
	"flex-colLCenterMiddle": `flex-colLCenterMiddle_kjXM7`,
	"flex-colCenterMiddle": `flex-colCenterMiddle_mD1TB`,
	"flex-colLStart": `flex-colLStart_snVAi`,
	"flex-colCenterStretch": `flex-colCenterStretch_tX7Wb`,
	"flex-rsrcToolbar": `flex-rsrcToolbar_cCT9X`,
	"flex-aggregationBucketFlex": `flex-aggregationBucketFlex_yzSFr`,
	"flex-aggregationContainerFlex": `flex-aggregationContainerFlex_Zx3Gm`,
	"flex-rowSReverse": `flex-rowSReverse_PQNdp`,
	"flex-toast": `flex-toast_XIW3m`,
	"flex-header": `flex-header_Fdqq6`,
	"flex-collection": `flex-collection_oobag`,
	"flex-projectButton": `flex-projectButton_apmPQ`,
	"flex-actionBarHorizontal": `flex-actionBarHorizontal_B7Szx`,
	"flex-conditionRowFlex": `flex-conditionRowFlex_OAVHQ`,
	"flex-actionBarDashboard": `flex-actionBarDashboard_vAGzb`
};
export default ___CSS_LOADER_EXPORT___;
